/**
 * Game.STATE, hoisted into its own module.
 *
 * In Java this is a nested enum, referenced everywhere as `Game.STATE.Menu`. Pulling it
 * out breaks what would otherwise be an import cycle through Game for every single UI file.
 * Read/write the live value via `Game.gameState`; name the constants via `STATE.Xxx`.
 */
export enum STATE {
  Menu,
  Profile,
  MusicPlayer,
  Settings,
  Statistics,
  AchievementsPage,
  Customize,
  Loadout,
  CoinShopPage,
  DailyPage,
  About,
  Update_Notes,
  Select,
  Help,
  HelpNLD,
  HelpENG,
  HelpFRA,
  HelpDEU,
  HelpRUS,
  HelpSPA,
  Shop,
  Game,
  Credits,
  End,
  Paused,
  Dying,
}
